import React from "react"
import BaseBlockContent from "@sanity/block-content-to-react"

import styles from "./simpleText.module.scss"

const SimpleText = ({ blocks }) => (
  <div className={styles.simpleText}>
    <BaseBlockContent blocks={blocks} />
  </div>
)

export default SimpleText
